import { NgModule } from '@angular/core';
import { FilterDropdownComponent } from './filter-dropdown.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from "@angular/common";

@NgModule({
  declarations: [FilterDropdownComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    CommonModule
  ],
  exports: [FilterDropdownComponent],
  providers:[]
})
export class FilterDropdownModule { }
